import {Component, Input, OnInit} from '@angular/core';
import {ModalDialogDismissOption} from '@shared/confirmation-dialog/modal-dialog-dismiss-option';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {GatewayService} from '@services/administration/gateway/gateway.service';
import {LoadingIndicatorService} from '@services/loading-indicator/loading-indicator.service';
import {TranslateService} from '@ngx-translate/core';
import {NotificationService} from '@services/notification/notification.service';

@Component({
    selector: 'scitis-admin-gateway-service-iba-configuration-modal',
    templateUrl: './iba-configuration-modal.component.html',
    styleUrls: ['./iba-configuration-modal.component.scss'],
    standalone: false
})
export class IbaConfigurationModalComponent implements OnInit {

  @Input()
  gatewayId: string = '';

  @Input()
  isAdminRole = false;

  @Input()
  isTechAdminRole = false;

  @Input()
  isSuperAdminRole = false;

  ibaConfig: any;
  keys: string[] = [];
  ibaConfigIsLoading = false;
  private COMPONENT_NAME: string = 'IbaConfigurationModalComponent';

  constructor(
      private activeModal: NgbActiveModal,
      private gatewayService: GatewayService,
      private loadingIndicator: LoadingIndicatorService,
      private translate: TranslateService,
      private notification: NotificationService,) {
  }

  ngOnInit(): void {
    this.setIbaConfig();
  }

  onClose() {
    this.activeModal.dismiss(ModalDialogDismissOption.CLOSE);
  }

  onCancel() {
    this.activeModal.dismiss(ModalDialogDismissOption.CANCEL);
  }

  onSubmit() {
    this.loadingIndicator.show(this.translate.instant('Loading'));
    this.gatewayService.saveIbaConfig(this.gatewayId, this.ibaConfig).subscribe(() => {
      this.activeModal.close();
      this.loadingIndicator.hide();
      this.notification.success('successfully saved ibaConfig', this.COMPONENT_NAME, false);
    }, (error) => {
      console.log('Error saving Iba configuration.', error);
      this.loadingIndicator.hide();
      this.notification.error('Error saving ibaConfig', error, this.COMPONENT_NAME, true);
    });
  }

  setValue(key, value): void {
    this.ibaConfig[key] = value;
  }

  private setIbaConfig(): void {
    this.ibaConfigIsLoading = true;
    this.gatewayService.getIbaConfig(this.gatewayId).subscribe((ibaConfig: any) => {
      this.ibaConfig = ibaConfig;
      this.keys = Object.keys(this.ibaConfig);
      this.ibaConfigIsLoading = false;
    }, (error) => {
      console.log('Error getting Iba configuration.', error);
      this.ibaConfigIsLoading = false;
    });
  }

}
